import { AsianReportViewTypes } from "app/utils/const";
import cx from "classnames";
import debounce from "lodash/debounce";
import React, { Component, lazy, Suspense } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { getEventDesktop } from "../../api/eventsApi";
import { FooterHelper } from "../../helpers/footerHelper";
import "./AsianOpenBetsScreen.scss";
import "./DateRangePicker.scss";
const AsianOpenBetsCurrentView: React.LazyExoticComponent<any> = lazy(
  () => import("./components/AsianOpenBetsCurrentView/AsianOpenBetsCurrentView")
);
const AsianOpenBetsHeader: React.LazyExoticComponent<any> = lazy(
  () => import("./components/AsianOpenBetsHeader/AsianOpenBetsHeader")
);
const ReportPagination: React.LazyExoticComponent<any> = lazy(
  () => import("../../components/ReportPagination/ReportPagination")
);
type Props = {
  loadOpenBetsNormalList: (...args: Array<any>) => any;
  loadOpenBetsLeagueList: (...args: Array<any>) => any;
  loadOpenBetsMatchList: (...args: Array<any>) => any;
  resetOpenBetsList: (...args: Array<any>) => any;
  totalBets: number;
  pageTotal?: number;
  setPositionMatrixModalItem: (...args: Array<any>) => any;
  currentView: string;
  resetPositionMatrix: (...args: Array<any>) => any;
  positionMatrixEvent: any;
  setPositionMatrixModalEvent: any;
  openPositionMatrixModal: (...args: Array<any>) => any;
  updateReportPagination: (...args: Array<any>) => any;
  updateFooterPlacement: (...args: Array<any>) => any;
};

type State = {
  normalViewDate: string;
  page: number;
  reportPaginationLoaded: boolean;
  footerEndOfPage: boolean;
};

const DEFAULT_PAGE_SIZE = 50;

class AsianOpenBetsScreen extends Component<Props, State> {
  query: string;
  selectedView: string;
  previousView: string;
  debouncedFetchNormalList: any;
  runnerId: any;
  competitionNavNodeId: any;

  constructor(props) {
    super(props);
    this.state = {
      currentView: AsianReportViewTypes.NORMAL,
      normalViewDate: "",
      page: 1,
      reportPaginationLoaded: false,
      footerEndOfPage: false,
    };
    this.query = "";
    this.selectedView = AsianReportViewTypes.NORMAL;
    this.runnerId = null;
    this.competitionNavNodeId = null;
    this.debouncedFetchNormalList = debounce(this.fetchOpenBetsList, 500);
    this.fetchOpenBetsList("");
  }

  fetchOpenBetsList = (query: string, page: number = 0) => {
    if (this.selectedView === AsianReportViewTypes.NORMAL) {
      this.props.loadOpenBetsNormalList({
        size: DEFAULT_PAGE_SIZE,
        page: page,
        filter: query,
        runnerId: this.runnerId,
        competitionNavNodeId: this.competitionNavNodeId,
      });
    } else if (this.selectedView === AsianReportViewTypes.LEAGUE) {
      this.props.loadOpenBetsLeagueList({
        filter: query,
        size: DEFAULT_PAGE_SIZE,
        page: page,
      });
    } else if (this.selectedView === AsianReportViewTypes.MATCH) {
      this.props.loadOpenBetsMatchList({
        filter: query,
        size: DEFAULT_PAGE_SIZE,
        page: page,
      });
    }
  };
  fetchNormalListByType = (type: string, id: any) => {
    this.setState(
      {
        page: 1,
      },
      () => {
        if (type === AsianReportViewTypes.MATCH) {
          this.runnerId = id;
        }

        if (type === AsianReportViewTypes.LEAGUE) {
          this.competitionNavNodeId = id;
        }

        this.previousView = type;
        this.selectedView = AsianReportViewTypes.NORMAL;
        this.query = "";
        // upate to stop flow error
        let searchEventsValue: Record<string, any> =
          document && document.querySelector("#search-events");
        if (searchEventsValue && searchEventsValue.value)
          searchEventsValue.value = "";
        this.fetchOpenBetsList(this.query);
      }
    );
  };
  fetchPreviousList = () => {
    this.setState(
      {
        page: 1,
      },
      () => {
        this.runnerId = null;
        this.competitionNavNodeId = null;
        this.selectedView = this.previousView;
        this.query = "";
        // upate to stop flow error
        let searchEventsValue: Record<string, any> =
          document && document.querySelector("#search-events");
        if (searchEventsValue && searchEventsValue.value)
          searchEventsValue.value = "";
        this.updateQuery(this.query);
      }
    );
  };
  onClickNewPage = (pageNumber: number) => {
    this.setState({
      page: pageNumber,
    });
    this.fetchOpenBetsList(this.query, pageNumber);
  };
  onInputChange = (id: string, value: string) => {
    this.query = value;

    if (this.state.page) {
      this.setState({
        page: 1,
      });
    }

    this.updateQuery(value);
  };
  onTypeChange = (event: Record<string, any>) => {
    this.selectedView = event.target.value;
    this.runnerId = null;
    this.competitionNavNodeId = null;
    this.setState({
      page: 1,
    });
    this.updateQuery(this.query);
  };
  onClickPositionMatrix = eventId => {
    getEventDesktop(eventId).then(eventData => {
      this.props.setPositionMatrixModalEvent(eventData);
      this.props.setPositionMatrixModalItem(eventData.id);
      this.props.openPositionMatrixModal();
    });
  };
  resetFilter = () => {
    this.query = "";
    // upate to stop flow error
    let searchEventsValue: any =
      document && document.querySelector("#search-events");
    if (searchEventsValue && searchEventsValue.value)
      searchEventsValue.value = "";
    this.fetchOpenBetsList(this.query);
    this.forceUpdate();
  };
  updateQuery = (value: string) => {
    const query = value;
    this.debouncedFetchNormalList(query);
  };
  calculateFooterPosition = () => {
    // check check where to position Footer component on page
    this.setState({
      footerEndOfPage:
        FooterHelper.checkWhereToPositionFooter("asian-open-bets"),
    });
  };
  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevProps !== this.props) {
      this.calculateFooterPosition();
    }
  };

  render() {
    const { totalBets, pageTotal, currentView } = this.props;
    let view = (
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <AsianOpenBetsCurrentView
          resetFilter={this.resetFilter}
          query={this.query}
          currentView={currentView}
          onClickPositionMatrix={this.onClickPositionMatrix}
          fetchNormalListByType={this.fetchNormalListByType}
        />
      </Suspense>
    );
    return (
      <div className="asian-open-bets">
        <Suspense fallback={<div className="fallback">loading...</div>}>
          <AsianOpenBetsHeader
            onTypeChange={this.onTypeChange}
            onInputChange={this.onInputChange}
            totalBets={totalBets}
            page={this.state.page}
            pageTotal={pageTotal}
            backToPreviousList={this.fetchPreviousList}
            previousView={this.previousView}
            currentView={currentView}
            reportType="OPENBETS"
            query={this.query}
            resetFilter={this.resetFilter}
          />
        </Suspense>
        <div
          className={cx("asian-open-bets__content", {
            "asian-open-bets__content--filtered": this.query !== "",
          })}
        >
          {view}
        </div>
        {pageTotal > 1 && currentView === AsianReportViewTypes.NORMAL && (
          <Suspense fallback={<div className="fallback">loading...</div>}>
            <ReportPagination
              page={this.state.page}
              pageTotal={pageTotal}
              onClickNewPage={this.onClickNewPage}
            />
          </Suspense>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  totalBets: state.openBetsListModel.openBetsTotal,
  pageTotal: state.openBetsListModel.totalPages,
  currentView: state.openBetsListModel.currentView,
  positionMatrixEvent: state.positionMatrixListModel.positionMatrixModalEvent,
});

const mapDispatchToProps = (dispatch: any) => ({
  setPositionMatrixModalEvent: event => {
    dispatch.positionMatrixListModel.setPositionMatrixModalEvent(event);
  },
  setPositionMatrixModalItem: (eventId: number) => {
    dispatch.positionMatrixListModel.setPositionMatrixModalItem({
      eventId: eventId,
    });
  },
  loadOpenBetsNormalList: ({
    size,
    page,
    filter,
    runnerId,
    competitionNavNodeId,
  }) => {
    dispatch.openBetsListModel.loadOpenBetsNormalList({
      size: size,
      page: page,
      filter: filter,
      runnerId: runnerId,
      competitionNavNodeId: competitionNavNodeId,
    });
  },
  loadOpenBetsLeagueList: ({ offset, filter }) => {
    dispatch.openBetsListModel.loadOpenBetsLeagueList({
      offset: offset,
      filter: filter,
    });
  },
  loadOpenBetsMatchList: ({ offset, filter }) => {
    dispatch.openBetsListModel.loadOpenBetsMatchList({
      offset: offset,
      filter: filter,
    });
  },
  resetOpenBetsList: () => {
    dispatch.openBetsListModel.resetOpenBetsList();
  },
  resetPositionMatrix: () => {
    dispatch.positionMatrixListModel.closePositionMatrixModal();
  },
  openPositionMatrixModal: () => {
    dispatch.positionMatrixListModel.openPositionMatrixModal();
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AsianOpenBetsScreen)) as any;
